import { Group, Image, Paper, SimpleGrid } from '@mantine/core';
export const Banks: React.FC = () => {
  return <Paper bg="var(--bg-600)" radius={5} p={{
    base: 10,
    sm: 20
  }}>
      <SimpleGrid cols={{
      base: 2,
      sm: 4
    }} spacing={{
      base: 10,
      sm: 20
    }}>
        <Paper h={50} radius={5} bg="var(--input-variant-color)">
          <Group h="100%" justify="center" align="center">
            <Image src="/assets/wallet/moonpay.svg" alt="wallet" style={{
            objectFit: 'contain'
          }} />
          </Group>
        </Paper>
        <Paper h={50} radius={5} bg="var(--input-variant-color)">
          <Group h="100%" justify="center" align="center">
            <Image src="/assets/wallet/chainbits.svg" alt="wallet" style={{
            objectFit: 'contain'
          }} />
          </Group>
        </Paper>
        <Paper h={50} radius={5} bg="var(--input-variant-color)">
          <Group h="100%" justify="center" align="center">
            <Image src="/assets/wallet/paybis.svg" alt="wallet" style={{
            objectFit: 'contain'
          }} />
          </Group>
        </Paper>
        <Paper h={50} radius={5} bg="var(--input-variant-color)">
          <Group gap={4} h="100%" justify="center" align="center">
            <Image src="/assets/wallet/visa.png" h={18} alt="wallet" />
            <Image src="/assets/wallet/mastercard.png" h={26} alt="wallet" />
          </Group>
        </Paper>
      </SimpleGrid>
    </Paper>;
};